export enum GridBlockType {
  TEXT = 'TEXT',
  IMAGE = 'IMAGE',
  SIGNATURE = 'SIGNATURE',
  TABLE = 'TABLE',
  VIDEO = 'VIDEO',
  SHAPE = 'SHAPE',
  EMBED = 'EMBED',
}

interface BlockSettingsDefault {
  blockType: GridBlockType;
  blockId: string;
  updatedByUserId: number;
  lockedBy?: number | null;
  updatedAt: string;
}

type BaseBlockType = {
  borderLeft: number;
  borderRight: number;
  borderTop: number;
  borderBottom: number;
  borderColor: string;
  borderRadius: number;
  paddingLeft: number;
  paddingRight: number;
  paddingTop: number;
  paddingBottom: number;
  rotation?: number;
};

export type TextBlockSettings = BaseBlockType & {
  backgroundColor: string;
};

export type ImageBlockSettings = BaseBlockType & {
  imageAlt: string;
  imageLink: string;
  opacity: number;
  imageAspectRatioLock: boolean;
  top?: number;
  objectFit?: string;
  objectPosition?: string;
};

export type ShapeBlockSettings = BaseBlockType & {
  backgroundColor: string;
};

export type EmbedBlockSettings = BaseBlockType & {
  embedUrl: string;
};

export type BlockSettings =
  | (BlockSettingsDefault & TextBlockSettings)
  | (BlockSettingsDefault & ImageBlockSettings)
  | (BlockSettingsDefault & ShapeBlockSettings);

export type BlockStyles = Partial<TextBlockSettings & ImageBlockSettings & ShapeBlockSettings>;
